import React from "react";
import { TailSpin } from "react-loader-spinner";

export default function Loader() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <TailSpin
        visible={true}
        height="80"
        width="80"
        color="#18406E"
        ariaLabel="tail-spin-loading"
        wrapperStyle={{}}
      />
    </div>
  );
}
